import { SortType } from './campaigns-models/campaign-filters';
import { StarRating } from './review';

export enum ReviewType {
  WITH_TEXT = 'withText',
  RATING_ONLY = 'ratingOnly'
}

export enum ReviewReply {
  REPLIED = 'replied',
  UNREPLIED = 'unreplied'
}

export enum ReviewEdit {
  EDITED = 'edited',
  UNEDITED = 'unedited'
}

export enum ReviewFilterNames {
  SORT_TYPE = 'sortType',
  REVIEW_TYPE = 'reviewType',
  REPLY = 'reply',
  EDIT = 'edit',
  RATING = 'rating',
  FROM = 'from',
  TO = 'to',
  CITIES = 'cities',
  COUNTRY_CODES = 'countryCodes',
  STORE_CODES = 'storeCodes',
  BUSINESS_NAMES = 'businessNames',
  GBP_ACCOUNT_IDS = 'gbpAccountIds'
}

export interface ReviewFilters {
  sortType: SortType
  reviewType: ReviewType,
  reply: ReviewReply,
  edit: ReviewEdit,
  rating: StarRating[],
  from: string; //ISO String in format: "2023-07-01T00:00:00.000Z"
  to: string; //ISO String in format: "2023-07-01T00:00:00.000Z"
  cities: string[];
  countryCodes: string[];
  storeCodes: string[];
  businessNames: string[];
  gbpAccountIds: string[];
}